module.exports = {"371603001":"富国街道","371603002":"富源街道","371603101":"下洼镇","371603102":"古城镇","371603103":"冯家镇","371603104":"泊头镇","371603105":"大高镇","371603106":"黄升镇","371603107":"滨海镇","371603203":"下河乡","371603204":"利国乡","371603205":"海防乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371603.json
// module id = 1494
// module chunks = 0